import React, { JSX } from 'react';
import Texts from '../../../assets/utils/texts';
import {
  Field,
  RichText,
} from '@sitecore-jss/sitecore-jss-nextjs';

type LocationBioProps = {
  locationSectionId?: string;
  servicesSectionId?: string;
  About?: Field<string>;
  LocationName?: Field<string>;
  LocationTypes?: {
    value: Array<{
      name: string;
      fields?: {
        Description?: Field<string>;
      };
    }>;
  };
  ServicesOffered?: Field<string>;
  Parking?: Field<string>;
  PrepareForYourFirstVisit?: Field<string>;
  CommittedToExcellence?: Field<string>;
};

const LocationBio = (
  props: LocationBioProps
): JSX.Element => {
  const {
    locationSectionId = 'location-overview',
    servicesSectionId = 'location-services',
    About,
    ServicesOffered,
    Parking,
    PrepareForYourFirstVisit,
    CommittedToExcellence,
  } = props;

  const hasLocationDetails = Boolean(
    About?.value?.trim() ||
      Parking?.value?.trim() ||
      PrepareForYourFirstVisit?.value?.trim() ||
      CommittedToExcellence?.value?.trim()
  );


  const hasServices = Boolean(
    ServicesOffered?.value?.trim()
  );

  return (
    <div className="location-result location-bio location-mobile-print active">
      {hasLocationDetails && (
  <section
    id={locationSectionId}
    className="location-overview-section location-anchor-target"
    itemProp="hospitalAffiliation"
    itemType="http://schema.org/Hospital"
    aria-labelledby="location-overview-heading"
  >
    <h2 id="location-overview-heading">
      Our Location
    </h2>

    <div className="location-details">
      {About?.value && (
        <div className="location-about">
          <RichText field={About} />
        </div>
      )}

      {Parking?.value && (
        <div className="location-parking">
          <h3>{Texts.Parking}</h3>
          <RichText field={Parking} />
        </div>
      )}

      {PrepareForYourFirstVisit?.value && (
        <div className="location-visit">
          <h3>
            {Texts.PrepareForYourFirstVisit}
          </h3>

          <RichText
            field={PrepareForYourFirstVisit}
          />
        </div>
      )}

      {CommittedToExcellence?.value && (
        <div className="location-about osf-body-copy">
          <h3>
            {Texts.CommittedToExcellence}
          </h3>

          <RichText
            field={CommittedToExcellence}
          />
        </div>
      )}
    </div>
  </section>
)}

      {hasServices && ServicesOffered && (
        <section
          id={servicesSectionId}
          className="location-services location-anchor-target"
          aria-labelledby="location-services-heading"
        >
          <h2 id="location-services-heading">
            {Texts.ServicesOffered}
          </h2>

          <RichText field={ServicesOffered} />
        </section>
      )}
    </div>
  );
};

export default LocationBio;